import { actionPriceClient } from "../clients/actionPriceClient"
import type {
  ActionPriceResponseDto,
  CreateActionPriceDto,
  UpdateActionPriceDto,
  ActionPriceListParams,
  ActionPriceListResponseDto,
  DeleteActionPriceResponseDto,
} from "../types/actionPrice.types"

/**
 * Action Price Service
 * Business logic layer - handles API responses, errors, and side effects
 */
export const actionPriceService = {
  /**
   * Get action price by ID (active only)
   */
  getActionPriceById: async (id: string): Promise<ActionPriceResponseDto> => {
    try {
      const actionPrice = await actionPriceClient.getActionPriceById(id)
      return actionPrice
    } catch (error: any) {
      throw error
    }
  },

  /**
   * List action prices (admin, optional isActive filter)
   */
  getActionPricesAdmin: async (
    params?: ActionPriceListParams
  ): Promise<ActionPriceListResponseDto> => {
    try {
      const response = await actionPriceClient.getActionPricesAdmin(params)
      return response
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Create action price
   */
  createActionPrice: async (
    data: CreateActionPriceDto
  ): Promise<ActionPriceResponseDto> => {
    try {
      const actionPrice = await actionPriceClient.createActionPrice(data)
      return actionPrice
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Update action price
   */
  updateActionPrice: async (
    id: string,
    data: UpdateActionPriceDto
  ): Promise<ActionPriceResponseDto> => {
    try {
      const actionPrice = await actionPriceClient.updateActionPrice(id, data)
      return actionPrice
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Delete action price
   */
  deleteActionPrice: async (id: string): Promise<DeleteActionPriceResponseDto> => {
    try {
      const response = await actionPriceClient.deleteActionPrice(id)
      return response
    } catch (error: any) {
      throw error
    }
  },
}

export default actionPriceService

